import CheckBoxIcon from '@material-ui/icons/CheckBox';
import CheckBoxOutlineBlankIcon from '@material-ui/icons/CheckBoxOutlineBlank';
import clsx from 'clsx';
import type { ReactElement } from 'react';
import React from 'react';

import styles from './Checkbox.module.css';

interface Props {
  label: string | ReactElement;
  onClick: (value: boolean) => void;
  checked: boolean;
}

export const Checkbox: React.FC<Props> = props => {
  const handleOnClick = () => {
    props.onClick(!props.checked);
  };
  return (
    <label className={styles.rememberMeCheckbox}>
      <span
        className={clsx(styles.rememberMeCheckboxInput, {
          [styles.checkboxChecked]: props.checked,
        })}
      >
        {props.checked ? <CheckBoxIcon /> : <CheckBoxOutlineBlankIcon />}
      </span>
      <input
        type="checkbox"
        className={styles.hideCheckbox}
        checked={props.checked}
        onChange={handleOnClick}
      />
      {props.label}
    </label>
  );
};
